import { render, staticRenderFns } from "./blockCo.vue?vue&type=template&id=28e75f30&scoped=true"
import script from "./blockCo.vue?vue&type=script&lang=js"
export * from "./blockCo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e75f30",
  null
  
)

export default component.exports